import { render, staticRenderFns } from "./editShopSmsSwitch.vue?vue&type=template&id=7224329a&scoped=true"
import script from "./editShopSmsSwitch.vue?vue&type=script&lang=js"
export * from "./editShopSmsSwitch.vue?vue&type=script&lang=js"
import style0 from "./editShopSmsSwitch.vue?vue&type=style&index=0&id=7224329a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7224329a",
  null
  
)

export default component.exports